<template>

    <div class="card card-with-shadow border-0 h-100 min-height-350" id="employee-statistics">
        <div class="card-header bg-transparent p-primary d-flex flex-column justify-content-between align-items-center">
            <h5 class="card-title text-capitalize mb-4 w-100">{{ $t('employee_statistics') }}</h5>
          <div class="row w-100">
            <ul class="nav tab-filter-menu d-flex flex-column justify-content-start align-items-start w-100">
              <li class="nav-item"
                  v-for="(item, index) in employeeStatisticFilters"
                  :key="index">
                <a href="#"
                   class="nav-link py-0 px-0"
                   :class="{'active': index === activeEmployeeStatisticsFilterIndex}"
                   @click.prevent="getFilterValue(item, index)">
                  {{ item.value }}
                </a>
              </li>
            </ul>
          </div>

        </div>
        <div class="card-body position-relative" :class="{'loading-opacity': preloader}">
            <app-overlay-loader v-if="preloader"/>
            <app-chart
                v-else
                type="horizontal-line-chart"
                :height="380"
                :maximum-range="20"
                :labels="employeeStatisticsLabels"
                :data-sets="employeeStatisticsDataSet"
            />
        </div>
    </div>

</template>

<script>
import {numberFormatter} from "../../../../../common/Helper/Support/SettingsHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {APP_DASHBOARD} from "../../../../Config/ApiUrl";

export default {
    name: "employeeStatistics",
    data() {
        return {
            numberFormatter,
            preloader: false,

            activeEmployeeStatisticsFilterIndex: 0,
            employeeStatisticFilterValue: 'by_designation',
            employeeStatisticFilters: [],
            employeeStatisticsLabels: [],
            employeeStatisticsDataSet: [
                {
                    borderWidth: 1,
                    barThickness: 25,
                    barPercentage: 0.5,
                    data: [],
                    borderColor: [],
                    backgroundColor: []
                }
            ],
        }
    },
    created() {
        this.setEmployeeStatisticFilters()
        this.getEmployeeStatisticsData();
    },
    methods: {
        setEmployeeStatisticFilters(){
            /*if (!!this.$can('view_employment_statuses')){
                this.employeeStatisticFilters.push({id: 'by_employment_status', value: this.$t('by_employment_status')})
            }*/
            if (!!this.$can('view_designations')){
                this.employeeStatisticFilters.push({id: 'by_designation', value: this.$t('by_designation')})
            }
            if (!!this.$can('view_departments')){
                this.employeeStatisticFilters.push({id: 'by_department', value: this.$t('by_department')})
            }
            if (!!this.$can('view_locations')){
                this.employeeStatisticFilters.push({id: 'by_location', value: this.$t('by_location')})
            }

            this.employeeStatisticFilterValue = this.employeeStatisticFilters[0]?.id

        },
        getFilterValue(item, index) {
            this.employeeStatisticFilterValue = item.id;
            this.activeEmployeeStatisticsFilterIndex = index;
            this.getEmployeeStatisticsData();
        },
        getEmployeeStatisticsData() {
            this.preloader = true;
            axiosGet(`${APP_DASHBOARD}/employee-statistics?key=${this.employeeStatisticFilterValue}`)
                .then(({data}) => {
                    this.employeeStatisticsLabels = Object.keys(data);
                    this.employeeStatisticsDataSet[0].data = Object.values(data);
                    this.employeeStatisticsDataSet[0].borderColor = Object.entries(data).map(color => '#019AFF');
                    this.employeeStatisticsDataSet[0].backgroundColor = Object.entries(data).map(color => '#019AFF');
                    this.preloader = false;
                })
                .catch((err) => {
                    this.$toastr.e(err.message);
                })
        },

    },
}
</script>
